import { useTheme } from '@emotion/react';
import { Image } from '../picture/picture';
import ViewSVG from '../../public/img/views2.svg';
import { H1 } from '../styled/typography';
import { DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';
import { Place } from '../../models';
import FavoriteButton from '../favorite/FavoriteButton';
import FavoriteButtonWrapper from '../favorite/FavoriteButtonWrapper';
import { FavoriteKinds } from '../../models/favorite';
import StarSVG from '../../public/img/star.svg';
import wordDeclension from '../../utils/word-declension';

export function PlaceBanner({ item }: { item: Place }) {
  const theme = useTheme();
  return (
    <div
      css={{
        position: 'relative',
        width: '100%',
        height: 400,
        overflow: 'hidden',
      }}
    >
      <Image
        css={{
          position: 'absolute',
          inset: 0,
          height: '100%',
          width: '100%',
          objectFit: 'cover',
          zIndex: 1,
        }}
        loading='eager'
        image={item.images[0]}
        alt={item.title}
      />
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          position: 'absolute',
          height: '100%',
          width: '100%',
          objectFit: 'cover',
          zIndex: 2,
          padding: '35px 20px 40px',
          color: theme.colors.white,
          background:
            'linear-gradient(180deg, rgba(19, 19, 19, 0) 25.52%, #131313 100%)',
          [DEVICE_SCREENS_MAX_STRING.md]: {
            padding: 20,
          },
        }}
      >
        <div
          css={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <div
            css={{
              display: 'flex',
              alignItems: 'center',
              gap: 16,
              [DEVICE_SCREENS_MAX_STRING.md]: {
                display: 'none',
              },
            }}
          >
            {!!item.views && (
              <div css={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                <ViewSVG css={{ width: 20, height: 18 }} /> {item.views}
              </div>
            )}
          </div>
        </div>
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 5,
          }}
        >
          <div css={{ display: 'flex', alignItems: 'flex-end' }}>
            {item.comments_avg_rating > 0 && (
              <>
                <StarSVG css={{ width: 16, height: 16, color: '#FFC907' }} />
                <span
                  css={{
                    fontFamily: 'Montserrat',
                    fontSize: 18,
                    lineHeight: '14px',
                    fontWeight: 'bold',
                    margin: '0 8px',
                  }}
                >
                  {item.comments_avg_rating.toFixed(1)}
                </span>
              </>
            )}
            {item.comments_count > 0 && (
              <button
                onClick={() => {
                  const el = document.querySelector('.comments-block');
                  if (el) {
                    el.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                type='button'
                css={{
                  fontSize: 12,
                  textDecoration: 'underline dashed',
                  lineHeight: '14px',
                  ':hover': {
                    textDecoration: 'none',
                  },
                }}
              >
                {`${item.comments_count} 
              ${wordDeclension(
                item.comments_count,
                'отзыв',
                'отзыва',
                'отзывов'
              )}
              `}
              </button>
            )}
          </div>
          <div
            css={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <H1
              css={{
                color: '#F8F8F8',
                fontFamily: 'Montserrat',
                [DEVICE_SCREENS_MAX_STRING.md]: {
                  maxWidth: '100%',
                },
              }}
            >
              {item.title}
            </H1>
            <FavoriteButtonWrapper {...{ maxHeight: 40 }} actionShip>
              <FavoriteButton
                kind={FavoriteKinds.place}
                id={item.id}
                size='medium'
                variant='red-outline'
                actionShip
              />
            </FavoriteButtonWrapper>
          </div>
          <div
            css={{
              display: 'none',
              alignItems: 'center',
              gap: 16,
              fontSize: 12,
              marginTop: 8,
              [DEVICE_SCREENS_MAX_STRING.md]: {
                display: 'flex',
              },
            }}
          >
            {!!item.views && (
              <div css={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                <ViewSVG
                  css={{
                    width: 20,
                    height: 18,
                    [DEVICE_SCREENS_MAX_STRING.md]: {
                      width: 20,
                      height: 15,
                    },
                  }}
                />{' '}
                {item.views}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
